<template>
    <footer class="app-footer">
        <div class="footer-inner">
            <!-- Sol: İletişim -->
            <div class="footer-col footer-contact mt-1">
                <span class="contact-item">
                    <feather-icon icon="PhoneIcon" size="13" />
                    {{ $param("company.phone") }}
                </span>
                <span class="contact-item">
                    <feather-icon icon="MapPinIcon" size="13" />
                    {{ $param("company.address") }}
                </span>
            </div>

            <!-- Orta: Güvenlik -->
            <div class="footer-col footer-security">
                <div class="security-card mt-1">
                    <img src="@/assets/images/footer/ssl-secure.png" alt="SSL" height="22" />
                    <img src="@/assets/images/footer/3d-secure.png" alt="3D Secure" height="22" />
                    <span class="security-text">Sitemizde kredi kartı işlemleri 256-bit SSL sertifikası ile korunmaktadır. Ödemelerinizde 3D Secure (Güvenli Ödeme) altyapısı kullanılmaktadır.</span>
                </div>
            </div>

            <!-- Sağ: Linkler + Logolar -->
            <div class="footer-col footer-right">
                <div class="links-row">
                    <b-link :to="{ name: 'privacy-policy' }">Gizlilik Politikası</b-link>
                    <span class="divider">|</span>
                    <b-link :href="pdfLink" target="_blank">Kullanım Dokümanı</b-link>
                </div>
                <div class="brand-row">
                    <img src="@/assets/images/footer/visa-logo.png" alt="Visa" height="18" />
                    <img src="@/assets/images/footer/mastercard-logo.png" alt="Mastercard" height="18" />
                    <span class="copyright">© {{ new Date().getFullYear() }} Sedbim</span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
    name: "AppFooter",
    components: { BLink },
    data() {
        return {
            pdfLink: "usage-document.pdf",
        };
    },
};
</script>

<style lang="scss" scoped>
// Light mode
$bg-light: #ffffff;
$border-light: #e2e8f0;
$text-muted-light: #64748b;
$link-light: #08a1ae;
$security-bg-light: #f0fdf4;
$security-border-light: #bbf7d0;
$security-text-light: #166534;

// Dark mode
$bg-dark: #283046;
$border-dark: #3b4253;
$text-muted-dark: #8a8ea0;
$link-dark: #28c4d4;
$security-bg-dark: rgba(40, 196, 212, 0.1);
$security-border-dark: rgba(40, 196, 212, 0.25);
$security-text-dark: #5edce2;

.app-footer {
    background: $bg-light;
    border-top: 1px solid $border-light;
    padding: 0.5rem 1.25rem;

    .dark-layout & {
        background: $bg-dark;
        border-top-color: $border-dark;
    }
}

.footer-inner {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    @media (max-width: 992px) {
        flex-direction: column;
        gap: 0.625rem;
    }
}

// Ortak kolon stili
.footer-col {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

// Sol: İletişim
.footer-contact {
    align-items: flex-start;

    @media (max-width: 992px) {
        align-items: center;
    }

    .contact-item {
        display: inline-flex;
        align-items: center;
        gap: 0.3rem;
        font-size: 0.75rem;
        color: $text-muted-light;

        .dark-layout & {
            color: $text-muted-dark;
        }

        svg {
            color: $link-light;

            .dark-layout & {
                color: $link-dark;
            }
        }
    }
}

// Orta: Güvenlik
.footer-security {
    align-items: center;
    justify-content: center;

    .security-card {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.375rem 0.75rem;
        background: #f8fafc;
        border: 1px solid $border-light;
        border-radius: 6px;
        max-width: 600px;

        .dark-layout & {
            background: rgba(255, 255, 255, 0.05);
            border-color: $border-dark;
        }

        img {
            height: 22px;
            opacity: 0.9;

            .dark-layout & {
                filter: brightness(1.1);
            }
        }

        .security-text {
            font-size: 0.6875rem;
            font-weight: 500;
            color: $text-muted-light;

            .dark-layout & {
                color: $text-muted-dark;
            }
        }

        @media (max-width: 576px) {
            .security-text {
                display: none;
            }
        }
    }
}

// Sağ: Linkler + Logolar
.footer-right {
    align-items: flex-end;

    @media (max-width: 992px) {
        align-items: center;
    }

    .links-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.75rem;

        a {
            color: $link-light;
            text-decoration: none;
            font-weight: 500;

            &:hover {
                text-decoration: underline;
            }

            .dark-layout & {
                color: $link-dark;
            }
        }

        .divider {
            color: $border-light;

            .dark-layout & {
                color: $border-dark;
            }
        }
    }

    .brand-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        img {
            height: 18px;
            opacity: 0.8;

            .dark-layout & {
                filter: brightness(1.2);
            }
        }

        .copyright {
            font-size: 0.6875rem;
            color: $text-muted-light;
            margin-left: 0.25rem;

            .dark-layout & {
                color: $text-muted-dark;
            }
        }
    }
}
</style>
